import React from "react";
import {DEFAULT_ZOOM, SCHEMA_MAP} from "../Const";

class AbstractMode extends React.Component {

    static defaultProps = {
        categories: [],
        members: [],
        filter: {
            radius: 50
        },
        mapProps: {
            center: {
                lat: 50.8835239,
                lng: 10.2,
            },
            zoom: DEFAULT_ZOOM,
            loading: false,
            height: 'calc(100vh - 83px)'
        },
        libraries: ['places'],
        onSelectCategory: (event) => {},
        onSelectPlace: (place) => {},
        handleGeoPosition: (event) => {},
        version: 'MOBILE'
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedMarker: {
                key: null,
                member: {}
            },
            schema: SCHEMA_MAP,
            isFilterOpen: false,
            isFilterOpenDesktop: true,
            sidebaropen: true
        }
    }

    onFilterChange = () => {
        this.setState({
            selectedMarker: {
                key: null,
                member: {}
            },
        })
    }

}

export default AbstractMode;
